import { HorariolaboralRegimen, HorariosCambioPRN } from 'components/UsuarioGeneral/Permisos/Solicitud Permisos/TypesSolicitudesPermisos';
import { EmpleadoHorario } from 'components/UsuarioGeneral/Solicitud Cambio Horario/TypesCambioHorarioPRN';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Button, Col, Row } from 'reactstrap';

import SelectItem2 from 'components/Varios/SelectNew';
import { SelectCombo } from 'components/Types/GeneralTypes';

import add from 'date-fns/add'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import { GetNPreviousLaboralDay, ObtenerFechaLaboralDeSuma, SumarDiasFecha, formatDateToString, toHoursAndMinutes } from 'functions/DatesFunctions';
import Datepicker2 from '../DatepickerNew';
import DatepickerModal from 'components/Varios/DatePickerModal';
import { isFeriado, isFeriadoFilter, isWeekday } from 'functions/CalendarFunctions';

import 'assets/scss/ModalCambioHorario.scss'
import WarningSVG from "assets/icons/Permisos/Informativa R.svg"


export type PropsModalCambiarHorarioCRN = {
    isOpen: boolean;
    toggle: () => void;
    onSave: (data: any) => void;
    feriados: Date[];
    empHorario: EmpleadoHorario[]
    horarioLaboralRegimen: HorariolaboralRegimen
    fechaDesdeActual: string | Date;
    fechaHastaActual: string | Date;
    horaDesdeActual: string;
    horaHastaActual: string;
    horaDesdeTardeActual: string;
    horaHastaTardeActual: string;
    idRegimenLaboral: number;
    listadoHorarios: HorariosCambioPRN[];
    archivo: string;
}

type HorarioMixto = {
    id: number;
    nombre: string;
    manana: string; // Formato "07:00 - 08:00"
    tarde?: string;  // Formato "14:30 - 15:30" (opcional)
};

type HorariosPorRegimen = Record<number, HorarioMixto[]>;

export default function ModalCambiarHorarioCRN(props: PropsModalCambiarHorarioCRN) {
    const { isOpen, toggle, onSave,
        feriados,
        empHorario,
        horarioLaboralRegimen,
        fechaDesdeActual,
        fechaHastaActual,
        horaDesdeActual,
        horaHastaActual,
        horaDesdeTardeActual,
        horaHastaTardeActual,
        idRegimenLaboral,
        listadoHorarios,
        archivo,
    } = props;

    const fechaActual = new Date();
    const fechaFormateada = fechaActual.toISOString().split('T')[0];
        
    const [fechaDesdeNueva, setFechaDesdeNueva] = useState<string>("");
    const [horaEntradaManana, setHoraEntradaManana] = useState<string>("");
    const [horaSalidaManana, setHoraSalidaManana] = useState<string>("");
    const [horaEntradaTarde, setHoraEntradaTarde] = useState<string>("");
    const [horaSalidaTarde, setHoraSalidaTarde] = useState<string>("");

    const [observacion, setObservacion] = useState<string>("")

    const [errorHoras, seterrorHoras] = useState<string>("")

    const esRegimenConHorariosPredefinidos = [7, 9].includes(idRegimenLaboral);
    const esRegimenConHorarioLibre = idRegimenLaboral === 8;

    const [horarioSeleccionadoId, setHorarioSeleccionadoId] = useState<number | null>(null);

    const [alertMessage, setAlertMessage] = useState<{ message: string, isError: boolean } | null>(null);

    // Estado para manejar los diferentes tipos de errores
    const [errorMismoHorario, setErrorMismoHorario] = useState<string>("");
    const [errorDuracionHoras, setErrorDuracionHoras] = useState<string>("");


    const resetearEstados = useCallback(() => {
        setFechaDesdeNueva("");
        setHoraEntradaManana("");
        setHoraSalidaManana("");
        setHoraEntradaTarde("");
        setHoraSalidaTarde("");
        setObservacion("");
        seterrorHoras("");
        setHorarioSeleccionadoId(null);
        setAlertMessage(null);
    }, []);

    // Función para mostrar alertas
    async function showAlertWarning(message, imageSrc, isError) {
        Swal.fire({
            html: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isError ? "Error" : "Warning",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    const formatHora = (hora: string) => {
        if (!hora) return "";
        // Convierte "08.00.00" -> "08:00" o mantiene "08:00" si ya está bien
        return hora.replace(/\./g, ":").split(":").slice(0, 2).join(":");
    };

    // Obtener horarios actuales según régimen
    const horariosDisponibles = (listadoHorarios || [])
        .filter(horario => horario.idRegimenLaboral === idRegimenLaboral)
        // Filtro adicional para régimen 9 basado en horario laboral
        .filter(horario => {
            if (idRegimenLaboral !== 9) return true; // No aplicar filtro para otros regímenes

            const horaEntradaRegimen = props.horarioLaboralRegimen.horaEntrada;
            const horaInicioR1 = formatHora(horario.horaInicioR1);
            const horaFinR2 = formatHora(horario.horaFinR2 || horario.horaFinR1);

            // Si el horario laboral empieza a las 07:00, mostrar solo horarios que empiecen a las 07:00 o terminen a las 15:30
            if (horaEntradaRegimen === "07:00") {
                return horaInicioR1 === "07:00" || horaFinR2 === "15:30";
            }
            // Caso contrario, mostrar los otros horarios (que no cumplan las condiciones anteriores)
            return horaInicioR1 !== "07:00" && horaFinR2 !== "15:30";
        })
        .map((horario, index) => ({  // Usamos el índice para numeración única
            id: index + 1,  // ID único basado en posición (1, 2, 3...)
            nombre: `Horario ${index + 1}`,  // Numeración correlativa
            manana: formatHora(horario.horaInicioR1) + " - " + formatHora(horario.horaFinR1),
            tarde: horario.horaInicioR2 && horario.horaFinR2
                ? formatHora(horario.horaInicioR2) + " - " + formatHora(horario.horaFinR2)
                : undefined
        }));

    // Función para calcular diferencia en horas entre dos strings "HH:MM"
    const calcularDiferenciaHoras = useCallback((horaInicio: string, horaFin: string): number => {
        if (!horaInicio || !horaFin) return 0;

        try {
            const [hIni, mIni] = horaInicio.split(':').map(Number);
            const [hFin, mFin] = horaFin.split(':').map(Number);

            // Validar formatos correctos
            if (isNaN(hIni)) throw new Error(`Hora inicio inválida: ${horaInicio}`);
            if (isNaN(hFin)) throw new Error(`Hora fin inválida: ${horaFin}`);

            return ((hFin * 60 + mFin) - (hIni * 60 + mIni)) / 60;
        } catch (error) {
            console.error('Error al calcular diferencia de horas:', error);
            return 0;
        }
    }, []);

    const validarHorarioLibre = (): boolean => {
        // Validación básica de campos requeridos
        if (!horaEntradaManana || !horaSalidaManana) {
            setAlertMessage({ message: "Por favor complete al menos el primer horario", isError: true });
            return false;
        }

        if (!validarRangoHorario(horaEntradaManana) ||
            !validarRangoHorario(horaSalidaManana) ||
            (horaEntradaTarde && !validarRangoHorario(horaEntradaTarde)) ||
            (horaSalidaTarde && !validarRangoHorario(horaSalidaTarde))) {
            setAlertMessage({ message: "Las horas deben estar entre 7:00 y 19:00", isError: true });
            return false;
        }

        const tieneHorarioTarde = horaEntradaTarde && horaSalidaTarde;
        let errorMsg = "";

        if (!tieneHorarioTarde) {
            // Validación para solo horario mañana
            const diffManana = calcularDiferenciaHoras(horaEntradaManana, horaSalidaManana);
            const [hIni, mIni] = horaEntradaManana.split(':').map(Number);
            const [hFin, mFin] = horaSalidaManana.split(':').map(Number);

            if (hIni > hFin) {
                errorMsg = `La hora de inicio del permiso no puede ser mayor a su hora de finalización`;
            } else if (diffManana !== 2) {
                errorMsg = `El horario debe ser exactamente de 2 horas`;
            }
        } else {
            // Validación para horario mixto
            const diffManana = calcularDiferenciaHoras(horaEntradaManana, horaSalidaManana);
            const diffTarde = calcularDiferenciaHoras(horaEntradaTarde, horaSalidaTarde);
            const totalHoras = diffManana + diffTarde;

            if (totalHoras !== 2) {
                errorMsg = `El horario debe ser exactamente de 2 horas <br>(primer horario: 1h, segundo horario: 1h)`;
            }
        }

        if (errorMsg) {
            setAlertMessage({ message: errorMsg, isError: true });
            return false;
        }

        return true;
    };

    // Efecto para validar si es el mismo horario (aplica a todos los regímenes)
    useEffect(() => {
        const mismoHorario = sonHorariosIguales(
            horaDesdeActual,
            horaHastaActual,
            horaDesdeTardeActual,
            horaHastaTardeActual,
            horaEntradaManana,
            horaSalidaManana,
            horaEntradaTarde,
            horaSalidaTarde
        );

        setErrorMismoHorario(mismoHorario ? "Está seleccionando el mismo horario actual" : "");
    }, [
        horaEntradaManana,
        horaSalidaManana,
        horaEntradaTarde,
        horaSalidaTarde,
        horaDesdeActual,
        horaHastaActual,
        horaDesdeTardeActual,
        horaHastaTardeActual
    ]);

    // Efecto para validar duración de 2 horas (solo régimen libre)
    useEffect(() => {
        if (esRegimenConHorarioLibre) {
            const diffManana = calcularDiferenciaHoras(horaEntradaManana, horaSalidaManana);
            const diffTarde = horaEntradaTarde && horaSalidaTarde
                ? calcularDiferenciaHoras(horaEntradaTarde, horaSalidaTarde)
                : 0;

            const error =
                (horaEntradaManana && horaSalidaManana && diffManana !== 2 && !horaEntradaTarde) ||
                    (horaEntradaTarde && horaSalidaTarde && (diffManana + diffTarde) !== 2)
                    ? "La duración total debe ser de 2 horas exactamente"
                    : "";

            setErrorDuracionHoras(error);
        } else {
            setErrorDuracionHoras("");
        }
    }, [
        horaEntradaManana,
        horaSalidaManana,
        horaEntradaTarde,
        horaSalidaTarde,
        esRegimenConHorarioLibre
    ]);

    // Función para obtener el error prioritario
    const getErrorPrioritario = () => {
        return errorMismoHorario || errorDuracionHoras;
    };

    // Efecto para manejar las alertas
    useEffect(() => {
        if (alertMessage) {
            showAlertWarning(alertMessage.message, WarningSVG, alertMessage.isError);
            setAlertMessage(null); // Limpiar el mensaje después de mostrarlo
        }
    }, [alertMessage]); 

    const handleToggle = useCallback(() => {
        resetearEstados();
        toggle();
    }, [toggle, resetearEstados]);

    const DatePickerFechaRigeCambio = useCallback(({ fechaInicioOriginal, fechaFinOriginal }) => {
        //console.log("fecha inicio: " + fechaInicioOriginal)
        //console.log("fecha fin: " + fechaFinOriginal)

        const feriadosFechas = props.feriados.map((val) => new Date(val));
        const excludeDates = [...feriadosFechas];

        // Convertir los strings a Date aquí mismo
        const fechaInicioDate = fechaInicioOriginal ? new Date(fechaInicioOriginal) : new Date();
        const fechaFinDate = fechaFinOriginal ? new Date(fechaFinOriginal) : new Date();

        const handleChangeFechaRigeCambio = (e) => {
            setFechaDesdeNueva(formatDateToString(e));
        };

        return (
            <DatepickerModal
                value={fechaDesdeNueva}
                name="fechadesde"
                id="fechadesde"
                onChange={handleChangeFechaRigeCambio}
                min={fechaInicioDate}  // Usar la fecha convertida
                max={fechaFinDate}    // Usar la fecha convertida
                excludeDates={excludeDates}
                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, feriados)}
                dayClassName={(date: Date) => isFeriado(date, feriados)}
                />
        )
    },[feriados])    

    const handleObservacionChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= 100) {
            setObservacion(valor);
        }
        
    };

    // Función para calcular el nuevo horario laboral
    const calcularNuevoHorarioLaboral = (horaEntrada: string, horaSalida: string, horaEntradaTarde?: string, horaSalidaTarde?: string) => {
        if (horaEntradaTarde && horaSalidaTarde) {
            // Horario mixto: el horario laboral va desde la primera hora de entrada hasta la última hora de salida
            return {
                horaEntradaLaboral: horaSalida,
                horaSalidaLaboral: horaEntradaTarde
            };
        } else {
            // Horario simple
            var [hora, minutos] = horaEntrada.split(':').map(Number);

            // Determinar si es horario de mañana (antes de las 12) o tarde
            if (hora < 12) {
                // Horario mañana: sumar 6 horas y 30 minutos
                [hora, minutos] = horaSalida.split(':').map(Number);
                const nuevaHora = hora + 6;
                const nuevosMinutos = minutos + 30;
                const horaFinal = nuevaHora + Math.floor(nuevosMinutos / 60);
                const minutosFinal = nuevosMinutos % 60;

                return {
                    horaEntradaLaboral: horaSalida,
                    horaSalidaLaboral: `${horaFinal.toString().padStart(2, '0')}:${minutosFinal.toString().padStart(2, '0')}`
                };
            } else {
                // Horario tarde: restar 6 horas y 30 minutos
                const nuevaHora = hora - 6;
                const nuevosMinutos = minutos - 30;
                const horaFinal = nuevaHora + (nuevosMinutos < 0 ? -1 : 0);
                const minutosFinal = (nuevosMinutos + 60) % 60;

                return {
                    horaEntradaLaboral: `${horaFinal.toString().padStart(2, '0')}:${minutosFinal.toString().padStart(2, '0')}`,
                    horaSalidaLaboral: horaEntrada
                };
            }
        }
    };

    const sonHorariosIguales = (
        horaEntradaActual: string,
        horaSalidaActual: string,
        horaEntradaTardeActual: string,
        horaSalidaTardeActual: string,
        horaEntradaNueva: string,
        horaSalidaNueva: string,
        horaEntradaTardeNueva?: string,
        horaSalidaTardeNueva?: string
    ): boolean => {
        // Normalizar valores vacíos/cero
        const tieneTardeActual = horaEntradaTardeActual && horaSalidaTardeActual &&
            horaEntradaTardeActual !== "00:00" && horaSalidaTardeActual !== "00:00";
        const tieneTardeNueva = horaEntradaTardeNueva && horaSalidaTardeNueva &&
            horaEntradaTardeNueva !== "00:00" && horaSalidaTardeNueva !== "00:00";

        // Comparar horario de mañana
        const mananaIgual =
            horaEntradaActual === horaEntradaNueva &&
            horaSalidaActual === horaSalidaNueva;

        // Si no hay horario de tarde en ninguno, solo comparar mañana
        if (!tieneTardeActual && !tieneTardeNueva) {
            return mananaIgual;
        }

        // Si uno tiene tarde válido y el otro no, no son iguales
        if (tieneTardeActual !== tieneTardeNueva) {
            return false;
        }

        // Comparar horario de tarde si ambos tienen
        const tardeIgual =
            horaEntradaTardeActual === horaEntradaTardeNueva &&
            horaSalidaTardeActual === horaSalidaTardeNueva;

        return mananaIgual && tardeIgual;
    };

    const handleSave = () => {
        //console.log('Valores actuales:', {
        //    horaEntradaManana,
        //    horaSalidaManana,
        //    horaEntradaTarde,
        //    horaSalidaTarde
        //});

        // Validación de fecha si es necesario
        if (archivo !== "" && !fechaDesdeNueva) {
            setAlertMessage({ message: "Por favor seleccione la fecha desde cuando rige este horario", isError: true });
            return;
        }

        // Validación para horario libre
        if (esRegimenConHorarioLibre && !validarHorarioLibre()) {
            return;
        }

        // Validación para horarios predefinidos
        if (esRegimenConHorariosPredefinidos && horarioSeleccionadoId === null) {
            setAlertMessage({ message: "Por favor seleccione un horario", isError: true });
            return;
        }

        // Obtener los nuevos horarios según el régimen
        let nuevaHoraEntrada = "";
        let nuevaHoraSalida = "";
        let nuevaHoraEntradaTarde: string | undefined = undefined;
        let nuevaHoraSalidaTarde: string | undefined = undefined;

        if (esRegimenConHorariosPredefinidos) {
            const horario = horariosDisponibles.find(h => h.id === horarioSeleccionadoId);
            if (!horario) return;

            [nuevaHoraEntrada, nuevaHoraSalida] = horario.manana.split(' - ');
            if (horario.tarde) {
                [nuevaHoraEntradaTarde, nuevaHoraSalidaTarde] = horario.tarde.split(' - ');
            }
        } else if (esRegimenConHorarioLibre) {
            nuevaHoraEntrada = horaEntradaManana;
            nuevaHoraSalida = horaSalidaManana;
            nuevaHoraEntradaTarde = horaEntradaTarde || undefined;
            nuevaHoraSalidaTarde = horaSalidaTarde || undefined;
        }

        // Validar que no sea el mismo horario actual
        const mismoHorario = sonHorariosIguales(
            horaDesdeActual,
            horaHastaActual,
            horaDesdeTardeActual || "", // Convertir undefined a string vacío para comparación
            horaHastaTardeActual || "", // Convertir undefined a string vacío para comparación
            nuevaHoraEntrada,
            nuevaHoraSalida,
            nuevaHoraEntradaTarde,
            nuevaHoraSalidaTarde
        );

        if (mismoHorario) {
            setAlertMessage({
                message: "No puede seleccionar el mismo horario que ya tiene actualmente",
                isError: true
            });
            return;
        }

        // Calcular nuevo horario laboral
        const nuevoHorarioLaboral = calcularNuevoHorarioLaboral(
            nuevaHoraEntrada,
            nuevaHoraSalida,
            nuevaHoraEntradaTarde,
            nuevaHoraSalidaTarde
        );

        // Preparar datos para enviar
        const data: any = {
            fechaDesde: archivo === "" ? formatDateToString(fechaDesdeActual) : fechaDesdeNueva,
            fechaHasta: formatDateToString(fechaHastaActual),
            observacion,
            horaEntrada: nuevaHoraEntrada,
            horaSalida: nuevaHoraSalida,
            horaEntradaLaboral: nuevoHorarioLaboral.horaEntradaLaboral,
            horaSalidaLaboral: nuevoHorarioLaboral.horaSalidaLaboral
        };

        // Agregar horario de tarde solo si existe
        if (nuevaHoraEntradaTarde && nuevaHoraSalidaTarde) {
            data.horaEntradaTarde = nuevaHoraEntradaTarde;
            data.horaSalidaTarde = nuevaHoraSalidaTarde;
        }

        //console.log(data);
        onSave(data);
        handleToggle(); // Usamos handleToggle en lugar de toggle
    };

    const validarRangoHorario = (hora: string): boolean => {
        const [horas] = hora.split(':').map(Number);
        return horas >= 7 && horas <= 19;
    };

    // Modificar la validación para el botón
    const validarErrores = () => {
        return !!getErrorPrioritario();
    };

    return (        
        <Modal isOpen={isOpen} toggle={handleToggle} className="modal-xl-custom2" centered size="xl" id="modalCRN">
            <ModalHeader
                toggle={handleToggle}
                className="text-center w-100"                
            >
                CAMBIAR HORARIO DEL PERMISO PARA EL CUIDADO DEL RECIÉN NACIDO
            </ModalHeader>
            <ModalBody className="modal-content-container">
                <FormGroup style={{ marginBottom: '0.8rem' }}> {/* Eliminamos la prop 'row' para que no sea fila horizontal */}
                    {/* Label separado en su propio div con clase de margen */}
                    <div className="mb-3"> {/* Añadimos margen inferior */}
                        <Label className="font-weight-bold">HORARIO ACTUAL DEL PERMISO PARA EL CUIDADO DEL RECIÉN NACIDO:</Label>
                    </div>

                    {/* Contenedor de campos en una fila */}
                    <FormGroup row> {/* Nuevo FormGroup con row para los campos */}
                        {horaDesdeTardeActual == "" ? (
                            <>
                                <Col md={3}>
                                    <Label for="fechadesde">Fecha desde</Label>
                                    <Input type="text" value={formatDateToString(fechaDesdeActual)} readOnly />
                                </Col>
                                <Col md={3}>
                                    <Label for="fechahasta">Fecha hasta</Label>
                                    <Input type="text" value={formatDateToString(fechaHastaActual)} readOnly />
                                </Col>
                                <Col md={3}>
                                    <Label for="horaentrada">Hora inicio</Label>
                                    <Input type="text" value={horaDesdeActual} readOnly />
                                </Col>
                                <Col md={3}>
                                    <Label for="horasalida">Hora fin</Label>
                                    <Input type="text" value={horaHastaActual} readOnly />
                                </Col>
                            </>
                        ) : (
                            <>
                                <Col md={2}>
                                    <Label for="fechadesde">Fecha desde</Label>
                                    <Input type="text" value={formatDateToString(fechaDesdeActual)} readOnly />
                                </Col>
                                <Col md={2}>
                                    <Label for="fechahasta">Fecha hasta</Label>
                                    <Input type="text" value={formatDateToString(fechaHastaActual)} readOnly />
                                </Col>
                                <Col md={4}>
                                    {/* Contenedor para horario mañana */}
                                    <div style={{ marginBottom: '1rem' }}>
                                        <Label for="horaentrada">Hora inicio</Label>
                                        <Input type="text" value={horaDesdeActual} readOnly />
                                    </div>
                                    <div>
                                            <Label for="horaentrada">Hora inicio</Label>
                                            <Input type="text" value={horaDesdeTardeActual} readOnly />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    {/* Contenedor para horario tarde */}
                                    <div style={{ marginBottom: '1rem' }}>
                                            <Label for="horasalida">Hora fin</Label>
                                            <Input type="text" value={horaHastaActual} readOnly />
                                    </div>
                                    <div>
                                        <Label for="horasalida">Hora fin</Label>
                                        <Input type="text" value={horaHastaTardeActual} readOnly />
                                    </div>
                                </Col>
                            </>
                        )}
                    </FormGroup>
                </FormGroup>
                <FormGroup style={{ marginBottom: '0.8rem' }}>
                    <Label>NUEVO HORARIO DEL PERMISO RIGE A PARTIR DE:</Label>                    
                </FormGroup>
                {esRegimenConHorariosPredefinidos && (
                    <FormGroup style={{ marginBottom: '0.8rem' }}>
                        <Row>
                            {(props.archivo == "") ? (
                                <Col md={6}>
                                    <Label for="fechadesde">Fecha desde</Label>
                                    <Input type="text" value={formatDateToString(fechaDesdeActual)} readOnly />
                                </Col>
                            ) : (
                                <Col md={6}>
                                    <Label for="fechadesde">Fecha desde</Label>
                                    <DatePickerFechaRigeCambio fechaDesdeOriginal={fechaFormateada} fechaFinOriginal={fechaHastaActual} />
                                </Col>
                            )}
                            <Col md={6}>
                                <Label for="fechahasta">Fecha hasta</Label>
                                <Input type="text" value={formatDateToString(fechaHastaActual)} readOnly />
                            </Col>
                        </Row>
                        <Label className="d-block text-center mb-2" style={{ fontSize: '1rem', fontWeight: '600', color: 'black' }}>
                            SELECCIONE NUEVO HORARIO
                        </Label>

                        {/* Mostrar información del horario seleccionado */}
                        {horarioSeleccionadoId && (
                            <div className="mb-4">
                                <Label>
                                    Horario seleccionado:
                                </Label>
                                <Row>
                                    {horariosDisponibles
                                        .filter(horario => horario.id === horarioSeleccionadoId)
                                        .map(horario => (
                                            <React.Fragment key={horario.id}>
                                                <Col md={3}>
                                                    <div style={{ marginBottom: '0.5rem' }}>
                                                        <Label for="horaentrada">Hora inicio</Label>
                                                        <Input
                                                            type="text"
                                                            value={horario.manana.split(' - ')[0]}
                                                            readOnly                                                            
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div style={{ marginBottom: '0.5rem' }}>
                                                        <Label for="horasalida">Hora fin</Label>
                                                        <Input
                                                            type="text"
                                                            value={horario.manana.split(' - ')[1]}
                                                            readOnly
                                                        />
                                                    </div>
                                                </Col>
                                                {horario.tarde && (
                                                    <>
                                                        <Col md={3}>
                                                            <div style={{ marginBottom: '0.5rem' }}>
                                                                <Label for="horaentrada">Hora inicio</Label>
                                                                <Input
                                                                    type="text"
                                                                    value={horario.tarde.split(' - ')[0]}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={3}>
                                                            <div style={{ marginBottom: '0.5rem' }}>
                                                                <Label for="horasalida">Hora fin</Label>
                                                                <Input
                                                                    type="text"
                                                                    value={horario.tarde.split(' - ')[1]}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </Col>
                                                    </>
                                                )}
                                            </React.Fragment>
                                        ))
                                    }
                                </Row>
                            </div>
                        )}

                        <div className="horario-container">
                            {horariosDisponibles.map((horario) => {
                                const [mananaInicio, mananaFin] = horario.manana.split(' - ');
                                const [tardeInicio, tardeFin] = horario.tarde?.split(' - ') || [];

                                const esHorarioActual = sonHorariosIguales(
                                    horaDesdeActual,
                                    horaHastaActual,
                                    horaDesdeTardeActual,
                                    horaHastaTardeActual,
                                    mananaInicio,
                                    mananaFin,
                                    tardeInicio,
                                    tardeFin
                                );

                                return (
                                    <div
                                        key={horario.id}
                                        className={`horario-item ${esHorarioActual ? 'horario-deshabilitado' : ''}`}
                                    >
                                        <div className="horario-title">{horario.nombre}</div>
                                        <div
                                            className={`horario-cell 
                        ${horarioSeleccionadoId === horario.id ? 'horario-selected' : ''}
                        ${esHorarioActual ? 'horario-deshabilitado' : ''}
                    `}
                                            onClick={() => !esHorarioActual && setHorarioSeleccionadoId(horario.id)}
                                        >
                                            {horario.tarde ? (
                                                <div>
                                                    {horario.manana} y {horario.tarde}
                                                </div>
                                            ) : (
                                                <div>{horario.manana}</div>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </FormGroup>
                )}
                {esRegimenConHorarioLibre && (
                    <>
                        <FormGroup row>
                            <>
                                {(props.archivo == "") ? (
                                    <Col md={2}>
                                        <Label for="fechadesde">Fecha desde</Label>
                                        <Input type="text" value={formatDateToString(fechaDesdeActual)} readOnly />
                                    </Col>
                                ) : (
                                    <Col md={2}>
                                        <Label for="fechadesde">Fecha desde</Label>
                                        <DatePickerFechaRigeCambio fechaDesdeOriginal={fechaFormateada} fechaFinOriginal={fechaHastaActual} />
                                    </Col>
                                )}
                                <Col md={2}>
                                    <Label for="fechahasta">Fecha hasta</Label>
                                    <Input type="text" value={formatDateToString(fechaHastaActual)} readOnly />
                                </Col>
                                <Col md={4}>
                                    <div style={{ marginBottom: '1rem' }}>
                                        <Label>Hora Inicio</Label>
                                        <Input
                                            type="time"
                                            min="07:00"
                                            max="17:00"
                                            value={horaEntradaManana}
                                            onChange={(v) => {
                                                // Si selecciona "00:00", lo tratamos como vacío
                                                const value = v.target.value === "00:00" ? "" : v.target.value;
                                                setHoraEntradaManana(value);
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <Label>Hora Inicio</Label>
                                        <Input
                                            type="time"
                                            min={horaSalidaManana || "09:00"}
                                            max="18:00"
                                            value={horaEntradaTarde}
                                            onChange={(v) => {
                                                // Si selecciona "00:00", lo tratamos como vacío
                                                const value = v.target.value === "00:00" ? "" : v.target.value;
                                                setHoraEntradaTarde(value);
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div style={{ marginBottom: '1rem' }}>
                                        <Label>Hora Fin</Label>
                                        <Input
                                            type="time"
                                            min={horaEntradaManana || "07:00"}
                                            max="19:00"
                                            value={horaSalidaManana}
                                            onChange={(v) => {
                                                // Si selecciona "00:00", lo tratamos como vacío
                                                const value = v.target.value === "00:00" ? "" : v.target.value;
                                                setHoraSalidaManana(value);
                                            }}
                                            disabled={!horaEntradaManana}
                                        />
                                    </div>
                                    <div>
                                        <Label>Hora Fin</Label>
                                        <Input
                                            type="time"
                                            min={horaEntradaTarde || "10:00"}
                                            max="19:00"
                                            value={horaSalidaTarde}
                                            onChange={(v) => {
                                                // Si selecciona "00:00", lo tratamos como vacío
                                                const value = v.target.value === "00:00" ? "" : v.target.value;
                                                setHoraSalidaTarde(value);
                                            }}
                                            disabled={!horaEntradaTarde}
                                        />
                                    </div>
                                </Col>
                            </>
                        </FormGroup>

                        {/* Mostrar error común debajo de ambos grupos */}
                        {getErrorPrioritario() && (
                            <div className="text-danger text-center mt-2 mb-3">
                                {getErrorPrioritario()}
                            </div>
                        )}
                    </>
                )}
                <FormGroup style={{ marginBottom: '0.8rem' }}>
                    <Label for="observaciones">Observación</Label>
                    <Input type="textarea" value={observacion} onChange={handleObservacionChange}/>
                </FormGroup>                
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
                <Button className="btn-cancelar-new" onClick={handleToggle}>CANCELAR</Button>
                <Button color="secondary" onClick={handleSave} disabled={validarErrores()}>CONFIRMAR</Button>
            </ModalFooter>
        </Modal>
    )
}
